"use client"

import { useRouter } from "next/navigation"
import { useEffect } from "react"



function page() {

    const Router = useRouter();

    useEffect(() => {
        Router.push("/auth/login")
    }, [])

  return (
    <div>page</div>
  )
}

export default page